// console.log(process.env.NODE_ENV)
let domain = "https://" + document.domain + "";
// console.log(domain)
export default domain;